import React, { lazy } from 'react';
import { Building, Home, Video } from 'lucide-react';
export default function AssessmentSection() {
  return <section className="py-16 bg-gray-50" data-id="element-189" data-mp="1q257s8oegv2x">
      <div className="container mx-auto px-4" data-id="element-190" data-mp="1q5avpklalqx2">
        <h2 className="text-3xl font-serif font-bold text-primary text-center mb-12" data-id="element-191" data-mp="24z630m5sv865">
          Additional Services – Prison, Home, and Remote Visits
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-192" data-mp="1cbjpom6rsp63">
          {/* Prison Visits */}
          <div className="bg-white p-6 rounded-lg shadow-md h-full" data-id="element-193" data-mp="17cguruki7zbu">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/18Vk7CVsLWHZnanuJYjKdC/Prison_Visits.png" alt="Prison psychiatric assessments by expert witness psychiatrist UK" className="w-full h-48 object-cover rounded-lg mb-4" width="800" height="384" loading="lazy" decoding="async" data-id="element-194" data-mp="17e9zv5fgybhq" />
            <div className="text-primary mb-4 flex justify-center" data-id="element-195" data-mp="ojv21j4w8ovh">
              <Building className="h-12 w-12" data-id="element-196" data-mp="8abmee7ar8zc" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2 text-center" data-id="element-197" data-mp="ccgc51umjlgp">
              Prison Visits
            </h3>
            <p className="text-slate text-center" data-id="element-198" data-mp="h4q0wek06fhe">
              In-person psychiatric assessments in secure settings. Dr Syed is
              available to conduct thorough evaluations within secure settings,
              ensuring timely assessments for legal proceedings.
            </p>
          </div>
          {/* Home Visits */}
          <div className="bg-white p-6 rounded-lg shadow-md h-full" data-id="element-199" data-mp="3pl1mmfiz5fii">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aQvbneRZRTrCPWszwKn2ay/Home_Visits.png" alt="Home psychiatric evaluations for medico-legal reports UK" className="w-full h-48 object-cover rounded-lg mb-4" width="800" height="384" loading="lazy" decoding="async" data-id="element-200" data-mp="3ugqdlugxho37" />
            <div className="text-primary mb-4 flex justify-center" data-id="element-201" data-mp="p1qb0be17ksz">
              <Home className="h-12 w-12" data-id="element-202" data-mp="k4gg4g7vigxr" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2 text-center" data-id="element-203" data-mp="k61dedlkodzb">
              Home Visits
            </h3>
            <p className="text-slate text-center" data-id="element-204" data-mp="u1l48lla4mh7">
              Compassionate assessments at home for comfort and convenience. Our
              priority is to ensure comfort and well-being, providing
              professional consultation in a familiar environment.
            </p>
          </div>
          {/* Remote Consultations */}
          <div className="bg-white p-6 rounded-lg shadow-md h-full" data-id="element-205" data-mp="g3wi7afh79ak">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rxyeXp7cZycaAAYrkvfcT9/Remote_Consultations.png" alt="Remote psychiatric expert witness consultations UK-wide" className="w-full h-48 object-cover rounded-lg mb-4" width="800" height="384" loading="lazy" decoding="async" data-id="element-206" data-mp="bbd4mdgsge5r" />
            <div className="text-primary mb-4 flex justify-center" data-id="element-207" data-mp="1z1awbyw0rlw0">
              <Video className="h-12 w-12" data-id="element-208" data-mp="1kc544uvlmvxm" />
            </div>
            <h3 className="text-xl font-serif font-bold text-primary mb-2 text-center" data-id="element-209" data-mp="1kdpu076yxqp5">
              Remote Consultations
            </h3>
            <p className="text-slate text-center" data-id="element-210" data-mp="2d127lrv5io6b">
              Nationwide video assessments via Zoom/Teams. In addition to
              in-person clinics across the UK, we offer remote consultations for
              clients who prefer this option.
            </p>
          </div>
        </div>
      </div>
    </section>;
}